import { render, staticRenderFns } from "./LoanTabsComponent.vue?vue&type=template&id=6ef90b9b&scoped=true&"
import script from "./LoanTabsComponent.vue?vue&type=script&lang=js&"
export * from "./LoanTabsComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoanTabsComponent.vue?vue&type=style&index=0&id=6ef90b9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef90b9b",
  null
  
)

export default component.exports